import { createBrowserRouter } from "react-router-dom";
import HomeLayout from "../Layouts/HomeLayout";
import HomeLayout02 from "../Layouts/HomeLayout02";
import HomeLayout03 from "../Layouts/HomeLayout03";
import HomeLayout04 from "../Layouts/HomeLayout04";
import ShopLayout from "../Layouts/ShopLayout";
import SobreNosotros from "../Pages/SobreNosotros";
import Blog from "../Pages/BlogPages/Blog";
import BlogDetails from "../Pages/BlogPages/BlogDetails";
import BlogDetails1 from "../Pages/BlogPages/BlogDetails1";
import BlogDetails2 from "../Pages/BlogPages/BlogDetails2";
import BlogDetails3 from "../Pages/BlogPages/BlogDetails3";
import CommingSoon from "../Pages/CommingSoon";
import Contacto from "../Pages/Contact";
import ErrorPage from "../Pages/ErrorPage";
import Home01 from "../Pages/HomePages/Home01";
import Home02 from "../Pages/HomePages/Home02";
import Home03 from "../Pages/HomePages/Home03";
import Home04 from "../Pages/HomePages/Home04";
import Home05 from "../Pages/HomePages/Home05";
import Home06 from "../Pages/HomePages/Home06";
import Home07 from "../Pages/HomePages/Home07";
import Home08 from "../Pages/HomePages/Home08";
import Home09 from "../Pages/HomePages/Home09";
import Home10 from "../Pages/HomePages/Home10";
import Login from "../Pages/Login";
import Project01 from "../Pages/ProjectPages/Project01";
import Project02 from "../Pages/ProjectPages/Project02";
import Project03 from "../Pages/ProjectPages/Project03";
import ProjectDetails from "../Pages/ProjectPages/ProjectDetails";
import ProjectDetails02 from "../Pages/ProjectPages/ProjectDetails02";
import Service01 from "../Pages/ServicePages/Service01";
import Service02 from "../Pages/ServicePages/Service02";
import ServiceDetails from "../Pages/ServicePages/ServiceDetails";
import Ebanisteria from "../Pages/ServicePages/Ebanisteria";
import Carpinteria from "../Pages/ServicePages/Carpinteria";
import Fabricacion from "../Pages/ServicePages/Fabricacion";
import Instalacion from "../Pages/ServicePages/Instalacion";
import Restauracion from "../Pages/ServicePages/Restauracion";
import Interiorismo from "../Pages/ServicePages/Interiorismo";
import AvisoLegal from "../Pages/Legal/AvisoLegal";
import PoliticaCookies from "../Pages/Legal/PoliticaCookies";
import PoliticaPrivacidad from "../Pages/Legal/PoliticaPrivacidad";
import Shop01 from "../Pages/ShopPages/Shop01";
import Shop02 from "../Pages/ShopPages/Shop02";
import Shop03 from "../Pages/ShopPages/Shop03";
import ShopCart from "../Pages/ShopPages/ShopCart";
import ShopCheckout from "../Pages/ShopPages/ShopCheckout";
import ShopProduct from "../Pages/ShopPages/ShopProduct";
import Team from "../Pages/TeamPages/Team";
import TeamDetails from "../Pages/TeamPages/TeamDetails";
import ThankYou from "../Pages/ThankYou";
import { productsAndCartData } from "../components/forJSON/getCart&ProductsData";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    children: [
      {
        path: "/",
        element: <Home01 />,
      },
      {
        path: "/home-3",
        element: <Home03 />,
      },
      {
        path: "/home-4",
        element: <Home04 />,
      },
      {
        path: "/home-5",
        element: <Home05 />,
      },
      {
        path: "/home-6",
        element: <Home06 />,
      },
      {
        path: "/home-8",
        element: <Home08 />,
      },
      {
        path: "/home-9",
        element: <Home09 />,
      },
      {
        path: "/project-1",
        element: <Project01 />,
      },
      {
        path: "/project-2",
        element: <Project02 />,
      },
      {
        path: "/project-3",
        element: <Project03 />,
      },
      {
        path: "/project-details",
        element: <ProjectDetails />,
      },
      {
        path: "/project-details-2",
        element: <ProjectDetails02 />,
      },
      {
        path: "/service-1",
        element: <Service01 />,
      },
      {
        path: "/service-2",
        element: <Service02 />,
      },
      {
        path: "/service-details",
        element: <ServiceDetails />,
      },
      {
        path: "/ebanisteria",
        element: <Ebanisteria />,
      },
      {
        path: "/Carpinteria",
        element: <Carpinteria />,
      },
      {
        path: "/fabricacion",
        element: <Fabricacion />,
      },
      {
        path: "/restauracion",
        element: <Restauracion />,
      },
      {
        path: "/instalacion-industrial",
        element: <Instalacion />,
      },
      {
        path: "/interiorismo",
        element: <Interiorismo />,
      },
      {
        path: "/aviso-legal",
        element: <AvisoLegal />,
      },
      {
        path: "/politica-privacidad",
        element: <PoliticaPrivacidad />,
      },
      {
        path: "/politica-cookies",
        element: <PoliticaCookies />,
      },

      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/coming-soon",
        element: <CommingSoon />,
      },
      {
        path: "/thank-you",
        element: <ThankYou />,
      },
      {
        path: "/team",
        element: <Team />,
      },
      {
        path: "/team-details",
        element: <TeamDetails />,
      },
      {
        path: "/contacto",
        element: <Contacto />,
      },
      {
        path: "/sobre-nosotros",
        element: <SobreNosotros />,
      },
      {
        path: "/noticias",
        element: <Blog />,
      },
      {
        path: "/blog-details",
        element: <BlogDetails />,
      },
      {
        path: "/la-armonia-entre-la-madera-y-el-diseno-de-interiores",
        element: <BlogDetails1 />,
      },
      {
        path: "/el-arte-y-ciencia-detras-del-proceso-de-construir-muebles-excepcionales",
        element: <BlogDetails2 />,
      },
      {
        path: "/renovando-historias-y-la-lmagia-de-la-restauracion-de-muebles-antiguos",
        element: <BlogDetails3 />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
  {
    path: "/",
    element: <HomeLayout02 />,
    children: [
      {
        path: "/home-2",
        element: <Home02 />,
      },
    ],
  },
  {
    path: "/",
    element: <HomeLayout03 />,
    children: [
      {
        path: "/home-7",
        element: <Home07 />,
      },
    ],
  },
  {
    path: "/",
    element: <HomeLayout04 />,
    children: [
      {
        path: "/home-10",
        element: <Home10 />,
      },
    ],
  },
  {
    path: "/",
    loader: productsAndCartData,
    element: <ShopLayout />,
    children: [
      {
        path: "/shop-1",
        element: <Shop01 />,
      },
      {
        path: "/shop-2",
        element: <Shop02 />,
      },
      {
        path: "/shop-3",
        element: <Shop03 />,
      },
      {
        path: "/product-details",
        element: <ShopProduct />,
      },
      {
        path: "/shop-cart",
        element: <ShopCart />,
      },
      {
        path: "/shop-checkout",
        element: <ShopCheckout />,
      },
      // {
      //     path: '/shop-product/:id',
      //     element: <SelectedProduct/>,
      //     loader: ({ params }) => fetch(`https://mrittik-server.vercel.app/products/${params.id}`)
      // },
      // {
      //     path: '/shop-category/:id',
      //     element: <ShopCategory/>,
      //     loader: ({ params }) => fetch(`https://mrittik-server.vercel.app/products/category/${params.id}`),
      // },
    ],
  },
]);